<template>
    <router-view></router-view>
</template>
<script>
import {
    defineComponent,
    onBeforeMount,
} from "vue";
import { useRoute } from 'vue-router'
import { useStore } from 'vuex';
export default defineComponent({
    setup() {
        let route = useRoute();
        let store = useStore();
        onBeforeMount(() => {
            console.log(route.query, 'route--main');
            if (route.query.from === 'mini') {
                store.dispatch('SETIsH5', true)
                store.commit('setuserOpenId', route.query.openid)
                store.dispatch('setAccessToken', route.query.access_token)
                store.dispatch('setRefreshToken', route.query.refresh_token)
            }
        });
    },
});
</script>
<style lang="scss" scoped>
</style>
